import { render, staticRenderFns } from "./totalCollectionOrderList.vue?vue&type=template&id=7b036d21&scoped=true"
import script from "./totalCollectionOrderList.vue?vue&type=script&lang=js"
export * from "./totalCollectionOrderList.vue?vue&type=script&lang=js"
import style0 from "./totalCollectionOrderList.vue?vue&type=style&index=0&id=7b036d21&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b036d21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b036d21')) {
      api.createRecord('7b036d21', component.options)
    } else {
      api.reload('7b036d21', component.options)
    }
    module.hot.accept("./totalCollectionOrderList.vue?vue&type=template&id=7b036d21&scoped=true", function () {
      api.rerender('7b036d21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/totalCollectionOrderList.vue"
export default component.exports